/**
* Carousel selector
*
* This function create an selector
*
*/

export const results = (state) => state.carouselReducer;
export const resultsItems = (state) => state.carouselReducer.data.data;
